import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { Bootstrap } from '../types/storefront'

interface TenantState {
  /** Vendor slug taken from the first path segment: /{slug}/... */
  slug: string | null
  bootstrap: Bootstrap | null
}

const initialState: TenantState = { slug: null, bootstrap: null }

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setSlug(state, action: PayloadAction<string | null>) {
      if (state.slug !== action.payload) state.bootstrap = null
      state.slug = action.payload
    },
    setBootstrap(state, action: PayloadAction<Bootstrap | null>) {
      state.bootstrap = action.payload
    },
  },
})

export const { setSlug, setBootstrap } = tenantSlice.actions
export default tenantSlice.reducer
